const BaseModule = require('../../../../90_utils/base/BaseModule');

class ReadMoreText extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$window = $(window);
		this.$readMore = this.$el.find('.read-more-goop .goop-button');
		this.$expandedContent = this.$el.find('.expanded-content');
		this.$overlayPanel = this.$el.find('.overlay-panel');

		this.expandedContentId = 'expanded-content' + (++window.SETTINGS.vars.svgIndex);
		this.transitionDelay;
		this.isIn = false;
	}

	// basemodule methods


	_domReady(){

		this.$expandedContent.css('height', 0);

		// enable modals from read more (weird)

		let modalId = this.$el.attr('data-modal-id') ? '#modal--' + this.$el.attr('data-modal-id') : '';

		if(modalId){
			this.$readMore.attr('data-modaal-href', modalId);
			this.$readMore.modaal();
		}

		this._resize();
	}

	_addListeners(){
		this.$readMore.on('click', $.proxy(this._onReadMoreClick, this));
		this.$window.on('scroll', $.proxy(this._onScroll, this));
	}

	_removeListeners(){
		this.$readMore.off('click', $.proxy(this._onReadMoreClick, this));
		this.$window.off('scroll', $.proxy(this._onScroll, this));
	}

	// listener methods

	_onReadMoreClick(e){
		this._toggleExpanded();
	}

	_onScroll(){

		let scrollTop = this.$window.scrollTop();
		let bounds = window.utils.PositioningUtils.getScrollOffset(this.$overlayPanel);
		let winHeight = window.SETTINGS.coords.winHeight;

		if((bounds.top < winHeight/2) || (bounds.height < winHeight && bounds.bottom < winHeight)){
			if((bounds.top < winHeight/3) || (bounds.height < winHeight && bounds.bottom <= winHeight)){
				if(!this.$el.hasClass('is-in')){
					this.$el.removeClass('is-in-slow');
					this.$el.addClass('is-in');
					this.isIn = true;

					if(this.transitionDelay){
						window.clearTimeout(this.transitionDelay);
					}
					this.transitionDelay = window.setTimeout(() => {
						this.$el.addClass('is-in-showing');
						this.transitionDelay = null;
						this._showText();
					}, 50);
				}
			}
			else {
				if(!this.$el.hasClass('is-in-slow')){
					this.$el.removeClass('is-in');
					this.$el.addClass('is-in-slow');
					this.isIn = true;

					if(this.transitionDelay){
						window.clearTimeout(this.transitionDelay);
					}
					this.transitionDelay = window.setTimeout(() => {
						this.$el.addClass('is-in-showing');
						this.transitionDelay = null;
						this._showText();
					}, 400);
				}
			}
		}
		else if(bounds.bottom < winHeight/4
			|| bounds.top > winHeight/4*3){

			if(this.isIn){
				this.$el.removeClass('is-in is-in-slow is-in-showing');
				this.isIn = false;
				this._hideText();

				if(this.transitionDelay){
					window.clearTimeout(this.transitionDelay);
					this.transitionDelay = null;
				}
			}
		}
	}

	// animate text

	_showText(){

		if(window.SETTINGS.breakpoint.minHeight('screen-medium')){

			let $title = this.$overlayPanel.find('.title');
			let $description = this.$overlayPanel.find('.description');
			let $expanded = this.$overlayPanel.find('.expanded-content');
			let $readMore = this.$overlayPanel.find('.read-more-goop');

			TweenMax.killTweensOf([$title, $description, $expanded, $readMore]);

			TweenMax.to($title, 0.4, {opacity:1, y:0, ease:'fade'});
			TweenMax.to($description, 0.4, {opacity:1, y:0, delay:0.1, ease:'fade'});
			TweenMax.to($expanded, 0.4, {opacity:1, y:0, delay:0.16, ease:'fade'});
			TweenMax.to($readMore, 0.4, {opacity:1, y:0, delay:0.2, ease:'fade'});
		}
	}

	_hideText(){

		if(window.SETTINGS.breakpoint.minHeight('screen-medium')){

			let $title = this.$overlayPanel.find('.title');
			let $description = this.$overlayPanel.find('.description');
			let $expanded = this.$overlayPanel.find('.expanded-content');
			let $readMore = this.$overlayPanel.find('.read-more-goop');

			TweenMax.killTweensOf([$title, $description, $expanded, $readMore]);

			TweenMax.to($title, 0.4, {opacity:0, y:0, ease:'fade'});
			TweenMax.to($description, 0.4, {opacity:0, y:0, delay:0.1, ease:'fade'});
			TweenMax.to($expanded, 0.4, {opacity:0, y:0, delay:0.16, ease:'fade'});
			TweenMax.to($readMore, 0.4, {opacity:0, y:0, delay:0.2, ease:'fade', onComplete:() => {
				TweenMax.set([$title, $description, $expanded, $readMore], {opacity: 0, y:20});
				TweenMax.set([$readMore], {opacity: 0, y:5});
			}});
		}
	}

	// toggle expanded content

	_toggleExpanded(){

		this.$el.toggleClass('is-expanded');
		this._checkExpandedHeight();
	}

	_checkExpandedHeight(instant){

		let $innerWrapper = this.$el.find('.overlay-panel');
		let $textContent = this.$el.find('.text-content');
		let $description = this.$el.find('.description');

		let elPadding = window.SETTINGS.breakpoint.minWidth('screen-small') ? 120 : 60;
		let contentPadding = window.SETTINGS.breakpoint.minWidth('screen-small') ? 160 : 60;
		let tweenTime = instant ? 0 : 0.3;

		if(this.$el.hasClass('is-expanded')){

			TweenMax.set(this.$expandedContent, {clearProps:'height'});

			let wrapperHeightFrom = $innerWrapper.outerHeight();
			let wrapperHeightTo = $textContent.outerHeight() + contentPadding;

			if($textContent.outerHeight() >= $innerWrapper.outerHeight() - contentPadding){
				TweenMax.to($innerWrapper, tweenTime, {opacity:1, height: wrapperHeightTo, ease:Cubic.easeOut});
			}

			if(wrapperHeightTo > this.$el.outerHeight() - elPadding){
				TweenMax.to(this.$el, tweenTime, {height: wrapperHeightTo + elPadding, ease:Cubic.easeOut});
			}

			// animate content expanding

			TweenMax.fromTo(this.$expandedContent, tweenTime, {opacity:0, height: 0},
				{opacity:1, height: this.$expandedContent.outerHeight(), ease:Cubic.easeOut});
		}
		else {

			// correct wrapper

			let wrapperHeightFrom = $innerWrapper.outerHeight();
			TweenMax.set($innerWrapper, {clearProps:'height'});

			TweenMax.set(this.$expandedContent, {height:0});
			let wrapperHeightTo = $textContent.outerHeight() + contentPadding;

			TweenMax.set($innerWrapper, {height: wrapperHeightFrom});
			TweenMax.to($innerWrapper, tweenTime, {height: wrapperHeightTo, ease:Cubic.easeOut});

			// resize wrapper

			let closedHeight = Math.max(window.SETTINGS.coords.winHeight, wrapperHeightTo + elPadding);
			TweenMax.to(this.$el, tweenTime, {height: closedHeight, ease:Cubic.easeOut});

			// shrink expanded content

			TweenMax.set(this.$expandedContent, {clearProps:'height'});
			TweenMax.to(this.$expandedContent, tweenTime, {opacity:0, height: 0, ease:Cubic.easeOut});
		}
	}

	//

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){

		let $innerWrapper = this.$el.find('.overlay-panel');
		let $textContent = this.$el.find('.text-content');

		TweenMax.set([this.$el, $innerWrapper], {clearProps: 'height'});

		let fitHeight = Math.max(window.SETTINGS.coords.winHeight, $innerWrapper.outerHeight() + 120);

		TweenMax.killTweensOf(this.$el);
		TweenMax.set(this.$el, {height: fitHeight});

		//

		if(!this.isIn){

			let $title = this.$overlayPanel.find('.title');
			let $description = this.$overlayPanel.find('.description');
			let $expanded = this.$overlayPanel.find('.expanded-content');
			let $readMore = this.$overlayPanel.find('.read-more-goop');

			if(window.SETTINGS.breakpoint.minHeight('screen-medium')){
				TweenMax.set([$title, $description, $expanded, $readMore], {opacity: 0, y:12});
				TweenMax.set([$description, $expanded], {opacity: 0, y:6});
				TweenMax.set([$readMore], {opacity: 0, y:3});
			}
			else {
				TweenMax.set([$title, $description, $expanded, $readMore], {clearProps: 'all'});
			}
		}

		//

		this._checkExpandedHeight(true);
	}
}

module.exports = ReadMoreText;
